import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://jatin-fb-ba.onrender.com/',
    
})

export default instance